var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissionIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0006 6C34.7848 6 43.7568 13.7595 45.6378 24C43.7568 34.2404 34.7848 42 24.0006 42C13.2162 42 4.2443 34.2404 2.36328 24C4.2443 13.7595 13.2162 6 24.0006 6ZM24.0006 38C32.4718 38 39.7206 32.104 41.5554 24C39.7206 15.8961 32.4718 10 24.0006 10C15.5292 10 8.28044 15.8961 6.44556 24C8.28044 32.104 15.5292 38 24.0006 38ZM24.0006 33C19.03 33 15.0005 28.9706 15.0005 24C15.0005 19.0294 19.03 15 24.0006 15C28.971 15 33.0006 19.0294 33.0006 24C33.0006 28.9706 28.971 33 24.0006 33ZM24.0006 29C26.762 29 29.0006 26.7614 29.0006 24C29.0006 21.2386 26.762 19 24.0006 19C21.2392 19 19.0005 21.2386 19.0005 24C19.0005 26.7614 21.2392 29 24.0006 29Z",
    fill: "#5784F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissionIcon3);
export default __webpack_public_path__ + "static/media/MissionIcon3.3c8cc48cf171b51a2325bf6db3d15d06.svg";
export { ForwardRef as ReactComponent };